import { getStableClassroomStudentId } from "@examspark/common";
import { ExamTicket, Student } from "@examspark/types";

import { GraphQLAPI } from "../..";
import { getStudent } from "../../queries/classroom";
import { getExamTicketQuery } from "../../queries/exam";

export const getExamTicket = async (params: { code?: string }) => {
  if (!params.code) return null;

  const result = await GraphQLAPI.client.query<{ getExamTicket: ExamTicket }>({
    authMode: "API_KEY",
    query: getExamTicketQuery,
    variables: {
      input: {
        id: params.code,
        sk: "exam-ticket",
      },
    },
  });

  // console.log({ result });
  return result.data?.getExamTicket ?? null;
};

export const getClassroomStudent = async (params: {
  classroomId: string;
  studentId?: string;
  service?: "google-classroom";
  caseSensitive?: boolean;
}) => {
  if (!params.studentId) return null;

  const result = await GraphQLAPI.client.query<{ getStudent: Student }>({
    authMode: "API_KEY",
    query: getStudent,
    variables: {
      input: {
        id: params.classroomId,
        sk: `student#${getStableClassroomStudentId(
          params.classroomId,
          params.studentId,
          {
            service: params.service,
            caseSensitive: params.caseSensitive,
          },
        )}`,
      },
    },
  });

  // console.log({ result });
  return result.data?.getStudent ?? null;
};
